import { Images, Tweens } from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CounterText from '../game/CounterText';
import NumberTile from '../game/NumberTile';
import PlayingGrid from '../game/PlayingGrid';
import PopupChain from '../game/PopupChain';
import TextTimer from '../game/TextTimer';
import gameData from '../gameData';
import { ADDITION, MULTIPLICATION } from '../gameParts';
import GameScreen from './GameScreen';

export default class InstructionsScreen extends Phaser.Scene {
  static get KEY() { return 'InstructionsScreen'; }

  create() {
    this.hand = null;
    this.simulateClick1Ran = false;
    this.simulateClick2Ran = false;
    this.simulateClick3Ran = false;
    this.currentTargetNumberValue = 0;
    this.gridCreatedFlag = false;

    Images.addImage(0, 0, 'yellow_background', this).setOrigin(0);

    const width = this.scale.width;
    const height = this.scale.height;

    this.bonusTimeSign = Images.addImage(150, 48, 'bonus_time_sign', this);

    this.textTimer = new TextTimer(this, 28, '#FFF');
    this.textTimer.x = 150;
    this.textTimer.y = 50;
    this.add.existing(this.textTimer);

    this.textTimer.start(100);

    this.targetNumberSign = new CounterText(this, '_VALUE_', 34, '#fff', 'target_number_sign');
    this.targetNumberSign.x = width / 2;
    this.targetNumberSign.y = this.targetNumberSign.getBounds().height / 2;

    this.targetNumberSign.setValue(this.currentTargetNumberValue);
    this.add.existing(this.targetNumberSign);

    this.scoreSign = new CounterText(this, '_VALUE_', 32, '#fff', 'score_sign_round');
    this.scoreSign.x = width - 150;
    this.scoreSign.y = this.scoreSign.getBounds().height / 2;
    if (gameData.gameType === MULTIPLICATION) this.scoreSign.y -= 6;
    this.scoreSign.setValue(0);
    this.add.existing(this.scoreSign);

    this.playingGrid = new PlayingGrid(this);
    this.playingGrid.x = (width / 2) - (this.playingGrid.sprite.width / 2);
    this.playingGrid.y = (height / 2) - (this.playingGrid.sprite.height / 2);
    this.add.existing(this.playingGrid);
    this.playingGrid.currentLevel = gameData.CURRENT_LEVEL;
    this.playingGrid.setupInitialBoard(true);
    this.playingGrid.on(NumberTile.TILE_SELECTED, (value) => {this.tileClicked(value);});
    this.playingGrid.on(PlayingGrid.TILES_ERASED, () => this.tilesErased());
    this.playingGrid.on(PlayingGrid.TARGET_HIT, () => {this.scoreSign.countToValue(6);});
    this.playingGrid.on(PlayingGrid.STAR_COLLECTED, () => {this.starsCollected++;});

    // for instructions, disable all clicking
    this.playingGrid.enabled = false;

    this.time.addEvent({ delay: 1900, callback: () => {this.playingGrid.addStarAtIndex();} });

    this.sentenceArea = new CounterText(this, '_VALUE_', 28, '#fff', 'number_sentence_area');
    this.sentenceArea.x = width / 2;
    this.sentenceArea.y = height - 70;
    this.sentenceArea.textLabel.y -= 15;
    this.sentenceArea.setValue('');
    this.add.existing(this.sentenceArea);

    // sets static number "6" for instructions
    const targetNumber = 6;
    this.targetNumberSign.setValue(targetNumber);

    this.hand = Images.addImage(400, 200, 'hand', this);

    const popupChain = new PopupChain(this, ['instructions1', 'instructions2', 'instructions3', 'instructions4', 'instructions5'], ['inst1', 'inst2', 'inst3', 'inst4', 'inst5']);
    popupChain.x = width / 2;
    popupChain.y = height / 2 + 30;
    this.add.existing(popupChain);
    popupChain.on(PopupChain.NEXT_DIALOG, (step) => {this.animateHand(step + 1);});
    this.playingGrid.on(PlayingGrid.GRID_CREATED, () => {popupChain.sprite.setInteractive();});

    this.animateHand(0);
  };

  tileClicked(value) {

    const len = this.sentenceArea.getValue().length;

    if (len < 39) {

      if (len === 0) {
        this.sentenceArea.addValue(`${value}`);
      }
      else {
        this.sentenceArea.addValue(` ${gameData.gameType === ADDITION ? '+' : '\u00D7'} ${value}`);
      }
    }
  }

  tilesErased() {

    this.sentenceArea.setValue('');

    this.currentSentenceValue = 0;
  }

  animateHand(step) {

    const width = this.scale.width;

    this.tweens.killTweensOf(this.hand);

    if (step === 0) {

      this.hand.x = 400;
      this.hand.y = 200;

      let counter = 1;

      const tween = function(hand) {
        Tweens.addTween(hand, 600, { y: hand.y - 20 }, Phaser.Math.Easing.Linear,() => {
          Tweens.addTween(hand, 600, { y: hand.y + 20 }, Phaser.Math.Easing.Linear,() => {
            counter++;
            if (counter !== 3) {
              tween(hand);
            }
          });
        });
      };

      tween(this.hand);
    }
    else if (step === 1) {

      Tweens.addTween(this.hand, 1000, { x: this.hand.x - 270, y: this.hand.y + 130 }, Phaser.Math.Easing.Linear,() => {
        Tweens.addTween(this.hand, 400, { scale: 0.85 }, Phaser.Math.Easing.Linear,() => {
          this.simulateClick(1, 1, 1);
          Tweens.addTween(this.hand, 400, { scale: 1 }, Phaser.Math.Easing.Linear, () => {
            tweenSequence2(this.hand, this.simulateClick, this);
          });
        });
      });

      const tweenSequence2 = () => {
        Tweens.addTween(this.hand, 500, { x: this.hand.x + 130 }, Phaser.Math.Easing.Linear,() => {
          Tweens.addTween(this.hand, 400, { scale: 0.85 }, Phaser.Math.Easing.Linear,() => {
            this.simulateClick(1, 2, 2);
            Tweens.addTween(this.hand, 400, { scale: 1 }, Phaser.Math.Easing.Linear, () => {
              tweenSequence3();
            });
          });
        });
      };

      const tweenSequence3 = () => {
        Tweens.addTween(this.hand, 500, { x: this.hand.x + 130 }, Phaser.Math.Easing.Linear,() => {
          Tweens.addTween(this.hand, 400, { scale: 0.85 }, Phaser.Math.Easing.Linear,() => {
            this.simulateClick(1, 3, 3);
            Tweens.addTween(this.hand, 400, { scale: 1 }, Phaser.Math.Easing.Linear, () => {
            });
          });
        });
      };
    }
    else if (step === 2) {

      this.hand.x = 440;
      this.hand.y = 305;

      if (!this.simulateClick1Ran) {this.simulateClick(1, 1, 1);}
      if (!this.simulateClick2Ran) {this.simulateClick(1, 2, 2);}
      if (!this.simulateClick3Ran) {this.simulateClick(1, 3, 3);}

      let counter = 1;

      const tween = () => {
        Tweens.addTween(this.hand, 600, { y: this.hand.y - 10 }, Phaser.Math.Easing.Linear, () => {
          Tweens.addTween(this.hand, 600, { y: this.hand.y + 10 }, Phaser.Math.Easing.Linear, () => {
            counter++;
            if (counter !== 5) {
              tween();
            }
          });
        });
      };

      tween();
    }
    else if (step === 3) {

      this.hand.x = 300;
      this.hand.y = 350;
      this.playingGrid.targetHit(false);

      Tweens.addTween(this.hand, 600, { x: this.hand.x - 130, y: this.hand.y - 150 }, Phaser.Math.Easing.Linear,() => {

      });

      let counter = 0;
      const tween = () => {
        Tweens.addTween(this.hand, 600, { y: 200 - 20 }, Phaser.Math.Easing.Linear, () => {
          Tweens.addTween(this.hand, 600, { y: 200 - 20 }, Phaser.Math.Easing.Linear, () => {
            counter++;
            if (counter !== 4) {
              tween();
            }
          });
        });
      };

      tween();
    }
    else if (step === 4) {

      this.hand.x = 150;
      this.hand.y = 350;

      this.sentenceArea.destroy();

      this.nextRoundButton = Images.addImage(0, 0, 'next_round_button', this);
      this.nextRoundButton.x = width / 2;
      this.nextRoundButton.y = 950;
      this.nextRoundButton.setInteractive();

      this.children.bringToTop(this.hand);

      this.nextRoundButton.on('pointerdown', () => {this.scene.start(GameScreen.KEY);});

      let counter = 0;

      const tween = () => {
        Tweens.addTween(this.hand, 600, { y: 1000 - 20 }, Phaser.Math.Easing.Linear, () => {
          Tweens.addTween(this.hand, 600, { y: 1000 + 20 }, Phaser.Math.Easing.Linear, () => {
            counter++;
            if (counter !== 4) {
              tween();
            }
          });
        });
      };

      Tweens.addTween(this.hand, 650, { x: this.hand.x + 250, y: this.hand.y + 650 }, Phaser.Math.Easing.Linear, () => {
        tween();
      });
    }
  }

  simulateClick(tileX, tileY, boolSwitchID, scene) {

    this.playingGrid.clickTile(tileX, tileY);

    switch (boolSwitchID) {
      case 1:
        this.simulateClick1Ran = true;
        break;
      case 2:
        this.simulateClick2Ran = true;
        break;
      case 3:
        this.simulateClick3Ran = true;
        break;
    }
  }

  /*

  cleanUp() {
    const event = new createjs.Event('TOGGLE_MUSIC');
    event._musicOn = false;
    this.dispatchEvent(event);

    while (this.getNumChildren() > 0) {
      this.removeChild(this.getChildAt(0));
    }

    this.parent.removeChild(this);
    this.dispatchEvent(abcya.GameStateEvents.GE_SHOW_GAME);
  };
  */
}